import {permissionManager} from "@/assets/plugins/mps-common/permissions/mps-permission-manager";

const install = (Vue, options) => {
    Vue.prototype.$permissionsManager = permissionManager;
};

export default {install}
